import request from '../utils/request';

export function getMenuList(param) {
  return request({
    url: '/admin/menu-in-all',
    method: 'GET',
    params: param
  })
}

export function getOutMenuList(param) {
  return request({
    url: '/admin/menu-out-all',
    method: 'GET',
    params: param
  })
}

export function deleteMenu(id) {
  return request({
    url: '/admin/menu/' + id,
    method: 'DELETE'
  })
}

export function createMenu(id,param) {
  if (id) {
    return request({
      url: '/admin/updateMenu',
      method: 'PUT',
      data: param
    })
  } else {
    return request({
      url: '/admin/createMenu',
      method: 'POST',
      data: param
    })
  }
}

export function getAllMenu(param) {
  return request({
    url: '/admin/getMenu',
    method: 'GET',
    params: param
  })
}

export function removeMenu(data) {
  return request({
    url: '/admin/deleteMenu',
    method: 'DELETE',
    data
  })
}